import * as React from "react"

import { GlobalState } from "../../../../../../store"
import { conceptSelector } from "../../../../../resources/adapters"
import { fetchConcept } from "../../../../../resources/thunks"
import { useAppDispatch, useAppSelector } from "../../../../../../hooks"

import Link from "../Link"
import UnavailableLink from "../UnavailableLink"

interface Props {
    attributes: Record<string, string>
    customLabel: string
    label: string
    conceptId: number
}

export const Concept = ({
    attributes,
    customLabel,
    label,
    conceptId,
}: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const resources = useAppSelector((state: GlobalState) => state.resources)
    const concept = conceptSelector.selectById(resources, conceptId)

    React.useEffect(() => {
        if (!concept) {
            dispatch(fetchConcept(conceptId))
        }
    }, [])

    if (!concept) {
        return (
            <UnavailableLink
                attributes={attributes}
                label={label}
                isLoading={true}
            />
        )
    } else if (concept.doesExist && !!concept.workspace?.doesExist) {
        const href = `workspace/${concept.workspace.id}/${concept.id}l`

        // we only show the title if there is no custom label
        const linkLabel = customLabel.length > 0 ? customLabel : concept.title

        return <Link attributes={attributes} label={linkLabel} href={href} />
    }

    return <UnavailableLink attributes={attributes} label={label} />
}

export default Concept
